<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row no-gutters>
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'"
      >
    <TopSpacePeople page="invites"/> 
      </v-col>
       <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? ' mx-auto d-flex justify-end' : 'mx-auto'"
      >
        <SearchBarExpanding v-if="totalUsers > 0" @input="searchPeople" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row
    v-if="users && users.length == 0 && usersInfo.currentPage == 1 && !loadingData && search == null"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyInvitationsPageTitle')"
          :page-text="$t('emptyInvitationsPageText')"
          page-image="image1"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="users && users.length > 0"
      align="center"
      class="mx-auto"
      :class="mobile() ? 'pa-3' : ''"
    >
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
          data-testid="user-card"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col cols="11"
                class="d-flex justify-left align-center "
              >
                <v-avatar
                  size="38"
                  class="ml-4 mr-1"
                >
                  <img :src="defaultImage"> 
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                  {{ user.attributes.user_email }}
                </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      data-testid="edit-role"
                      router
                      @click.stop="
                        selectedRole = user.attributes.for_role,
                        inviteId = user.id,
                        dialogVisibleChooseRole = true, 
                        confirmationDialogTitle = $t('confirmationDialogTitleChooseRole'), 
                        confirmationDialogText = $t('confirmationDialogTextChooseRole'), 
                        confirmationDialogSubmitBtn = $t('save')
                        confirmationDialogCancelBtn = $t('cancel')"
                    >
                      <v-list-item-title>{{ $t('editRole') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="show-resend-invite"
                      router
                      @click="resendInvitation(user)"
                    >
                      <v-list-item-title>{{ $t('resendInvitation') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="show-cancel-invite"
                      router
                      @click="cancelInvitation(user)"
                    >
                      <v-list-item-title>{{ $t('cancelInvitation') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                offset="3"
                offset-sm="2"
                class="align-center"
              >
                <v-chip v-if="user.content_shared_flag"
                  @click.stop="getContentAccess(user.id)"
                  data-testid="access-chip"
                >{{ $t('access') }}</v-chip>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                align="center"
                class="d-flex align-center justify-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <!-- <img v-if="user.attributes.avatar_thumb == null" :src="defailtImage" />
                  <img v-else :src="`${user.attributes.avatar_thumb}`"> -->
                  <img :src="defaultImage"> 
                </v-avatar>
              </v-col>

              <v-col
                md="8"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.user_email }}
                </div>
              </v-col>
              <v-col
                md="2"
                class="d-flex align-center"
              >
                <v-chip v-if="user.content_shared_flag"
                  @click.stop="getContentAccess(user.id)"
                  data-testid="access-chip"
                >{{ $t('access') }}</v-chip>
              </v-col>
              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      data-testid="edit-role"
                      router
                      @click.stop="
                        selectedRole = user.attributes.for_role,
                        inviteId = user.id,
                        dialogVisibleChooseRole = true, 
                        confirmationDialogTitle = $t('confirmationDialogTitleChooseRole'), 
                        confirmationDialogSubmitBtn = $t('save')
                        confirmationDialogCancelBtn = $t('cancel')"
                    >
                      <v-list-item-title>{{ $t('editRole') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="show-resend-invite"
                      router
                      @click="resendInvitation(user)"
                    >
                      <v-list-item-title>{{ $t('resendInvitation') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="show-cancel-invite"
                      router
                      @click="cancelInvitation(user)"
                    >
                      <v-list-item-title>{{ $t('cancelInvitation') }}</v-list-item-title>
                    </v-list-item>                    
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="users.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />

    <PlusButtonWithLink
      data-testid="invite-people-button"
      rounded="xxl"
      :link="link"
    />
    <ConfirmationDialogChooseRole
      v-if="dialogVisibleChooseRole"
      :visible="dialogVisibleChooseRole"
      :cd-title="confirmationDialogTitle"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :loading="loading"
      :selected-role="selectedRole"
      page="invites"
      data-testid="confirmation-dialog-choose-role"
      @close="dialogVisibleChooseRole=false"
      @proceedSubmit="updateRole"
    />
    <ConfirmationDialogShareContentOnInvite
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :content-confirmed = "sharedContentAccessPerInvitation"
      page="review-invitation"
      data-testid="confirmation-dialog"
      @close="dialogVisible = false"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getSpaceInviteUsers, cancelInvite, resendInvite,updateRole,searchInSpaceInviteUsers } from '../../api/spaceApi'
import Pagination from '../../components/Pagination'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import EmptyPage from '../../components/EmptyPage'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import ConfirmationDialogChooseRole from '../../components/ConfirmationDialogChooseRole'
import TopSpacePeople from './TopSpacePeople'
import SearchBarExpanding  from '../../components/SearchBarExpanding'
import Vue from "vue";
import ConfirmationDialogShareContentOnInvite from "../../components/ConfirmationDialogShareContentOnInvite.vue"

export default {
    components: {
        Pagination,
        PlusButtonWithLink,
        EmptyPage,
        AlertMessages,
        ConfirmationDialogChooseRole,
        TopSpacePeople,
        SearchBarExpanding,
        ConfirmationDialogShareContentOnInvite
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            users: [],
            usersInfo: { currentPage: 1, total: 0},
            alertMsg:'',
            alertType:'',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 15,
            link: {title: i18n.t('invitePeopleTitle'), route: '/audiences/invite'},
            loadingData: false,
            dialogVisibleChooseRole:false,
            inviteId:'',
            loading:false,
            search: null,
            paginationKey: '',
            dialogVisible: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            sharedContentAccess: [],
            sharedContentAccessPerInvitation: [],
            totalUsers: 0
        }
    },
    computed: {
      productPlan() {
        return this.$store.state.productPlan;
      }
    },
    async created(){
        
        if(this.$route.params.successfullyInvitedPeaple){     
            this.alertMsg = i18n.t('invitePeopleSuccess')
            this.alertValue = true
            this.alertType = 'success'
        }

        this.loadingData = true
        await this.fetchUsers()
        this.loadingData = false
    },
   methods:{
        async searchPeople(keyword){
            this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchInSpaceInviteUsers(this.spaceId,keyword,this.pageNumber, this.size)
                  if(response){
                      if(response.status == 200){
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.page.total > 0){
                              this.pageNumber = 1
                              await this.searchPeople(keyword)
                          }else {
                              this.usersInfo = response.data.meta.page
                              if(this.pageNumber == 1){
                                this.paginationKey = Date.now()
                              }
                              window.scrollTo(0,0)
                          } 
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },
        async resetSearch(){
          this.usersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchUsers()
          this.search = null
          this.paginationKey = Date.now()
          return
        },
        handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
                this.fetchUsers()
            }else {
                this.searchPeople(this.search)
            }
        },
        async fetchUsers(){
            try {
                const response = await getSpaceInviteUsers(this.spaceId, this.pageNumber, this.size)
                if(response.status == 200) {
                    this.users = response.data.data
                      if(this.users.length == 0 && response.data.meta.total > 0){
                        this.pageNumber = 1
                        await this.fetchUsers()
                    }else {
                        this.usersInfo = response.data.meta
                        this.totalUsers = response.data.meta.total
                        if(this.pageNumber == 1){
                          this.paginationKey = Date.now()
                        }
                        for(let i = 0; i < this.users.length; i++){
                            if(this.users[i].attributes.for_activity_titles.length > 0 || this.users[i].attributes.for_hub_titles.length > 0 || this.users[i].attributes.for_workflow_titles.length > 0) {
                              Vue.set(this.users[i], "content_shared_flag", true);
                              this.sharedContentAccess[this.users[i].id] = this.users[i].attributes.for_activity_titles.concat(this.users[i].attributes.for_hub_titles).concat(this.users[i].attributes.for_workflow_titles)
                            }
                        }
                        window.scrollTo(0,0)
                    } 
                    
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else{
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }           
            }           
        },
        async cancelInvitation(invite){
            try {
                const response = await cancelInvite(invite.id)
                if(response.status == 204) {
                    if(this.search == null){
                      await this.fetchUsers()
                    }else {
                      await this.searchPeople(this.search)
                    }
                    this.alertMsg =  i18n.t('inviteCancelSuccess')
                    this.alertValue = true
                    this.alertType = 'success'
                    this.$store.dispatch("getSpaceUsersStatistics", this.spaceId).catch(() => {
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError') 
                    })
                } 
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 404){
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('invitationNotFound')
                    }else{
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async resendInvitation(invite){
            try {
                const response = await resendInvite(invite.id) 
                if(response.status == 200) {
                    this.alertMsg =  i18n.t('invitePeopleSuccess')
                    this.alertValue = true
                    this.alertType = 'success'
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }   
            }
        },
        async updateRole(role){
          this.loading=true
           try {
                let data = {
                    data: {
                        type: "invitations", 
                        id: this.inviteId,
                        attributes: { 
                            for_role: role
                        }

                    }
                }
                const response = await updateRole(this.inviteId,data) 
                if(response.status == 200) {
                  if(this.search == null){
                      await this.fetchUsers()
                  }else {
                      await this.searchPeople(this.search)
                  }
                  this.alertValue = true
                  this.alertType = 'success'
                  this.alertMsg =  i18n.t('editRoleMsg')
                  this.$store.dispatch("getSpaceUsersStatistics", this.spaceId).catch(() => {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError') 
                  })
                }
            } catch (e) {             
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }   
            }
            this.dialogVisibleChooseRole=false
            this.loading=false
        },
        getContentAccess(id){
          this.sharedContentAccessPerInvitation = []
          this.confirmationDialogTitle = i18n.t('confirmationDialogShareContentInvitationReviewTitle')
          this.confirmationDialogText = i18n.t('confirmationDialogShareContentInvitationReviewText')
          this.sharedContentAccessPerInvitation = this.sharedContentAccess[id]
          this.dialogVisible = true
        }
    }
}
</script>

